export default __webpack_public_path__ + "static/media/quiz5.82284026.jpg";